<script>
  // core components
  import BancoView from "../../viewsERP/Banco.svelte";
</script>

<div class="flex flex-wrap mt-4">
  <div class="w-full mb-12 px-4">
    <BancoView />
  </div>
</div>